export const subscriptionsContext = {
  all: '/user-service/api/external/subscriptions',
  types: '/user-service/api/external/subscriptions/types',
};
